import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { firstValueFrom, map, Observable } from 'rxjs';
import {environment} from "../../../../../environments/environment";
import {
    MeedRiskWeekly,
    RiskAssessmentLog,
    RiskAssessmentLogResponse
} from "@shared/api/models/query/meed-risk.model";
import {RiskAssessmentLogCreate} from "@shared/api/models/command/risk-assessment-log.model";
import {Pagination, PaginationResponse} from "@models/pagination.model";

@Injectable({
    providedIn: 'root'
})
export class PatientMeedRisksService {

    constructor(private http: HttpClient) {
    }

    /**
     * Get MEED risk weekly data for a patient
     * GET /api/v2/patients/:id/meed-risk/weekly?date=YYYY-MM-DD
     */
    async getMeedRisksWeekly(patientId: number, date: string): Promise<MeedRiskWeekly[]> {
        const url = `${environment.baseApiUrl}v2/patients/${patientId}/meed-risks/weekly`;
        const params = {
            date: date
        }
        const result = this.http.get<MeedRiskWeekly>(url, {params: params})
            .pipe(
                map((response) => {
                    return [response];
                }),
            );
        return firstValueFrom(result);
    }

    /**
     * Get risk assessment logs for a patient
     * GET /api/v2/patients/:id/risk-assessment-logs
     */
    getRiskAssessmentLogs(patientId: number, pagination: Pagination = new Pagination()): Observable<PaginationResponse<RiskAssessmentLog>> {
        const url = `${environment.baseApiUrl}v2/patients/${patientId}/risk-assessment-logs`;
        const params = {
            size: pagination.size.toString(),
            start: (pagination.start * pagination.size).toString()
        };
        return this.http.get<RiskAssessmentLogResponse>(url, { params });
    }

    /**
     * Create a risk assessment log
     * POST /api/v2/patients/:id/risk-assessment-logs
     */
    createRiskAssessmentLog(patientId: number, actionTaken: "No action needed" | "Risk assessment updated", patientMeedRiskId: number): Observable<any> {
        const url = `${environment.baseApiUrl}v2/patients/${patientId}/risk-assessment-logs`;
        const payload: RiskAssessmentLogCreate = {actionTaken: actionTaken, patientMeedRiskId: patientMeedRiskId};

        return this.http.post<any>(url, payload);
    }
}
